var map = {
	".": "sHXP",
	"./": "sHXP",
	"./01_server_url": "wWlE",
	"./01_server_url.json": "wWlE",
	"./03_error_code": "/sx7",
	"./03_error_code.json": "/sx7",
	"./04_rate_limits": "bIsO",
	"./04_rate_limits.json": "bIsO",
	"./04_server_url": "GK5R",
	"./04_server_url.json": "GK5R",
	"./index": "sHXP",
	"./index.js": "sHXP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F9Rf";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/basic ^.*$
// module id = F9Rf
// module chunks = 3